module.exports = __webpack_public_path__ + "static/img/logo.7d0a968.png";


//////////////////
// WEBPACK FOOTER
// ./public/logo.png
// module id = WKWE
// module chunks = 7